export * from './ConversationSummary'
export * from './ConversationsQueryParamBuilder'
export * from './ConversationsTable'
export * from './ConversationHeader'
export * from './MessageBoard'
export * from './AiButton'
export * from './PublishRequiredCard'
export * from './PublishWarningDialog'

export const sentimentStyles: Record<string, string> = {
  very_positive: 'text-green-800 bg-green-200',
  positive: 'text-lime-800 bg-lime-200',
  neutral: 'text-neutral-800 bg-neutral-200',
  negative: 'text-orange-800 bg-orange-200',
  very_negative: 'text-red-800 bg-red-200',
  pending: 'text-neutral-800 bg-neutral-200',
}

export const sentimentLabels: Record<string, string> = {
  very_positive: 'Very Positive',
  positive: 'Positive',
  neutral: 'Neutral',
  negative: 'Negative',
  very_negative: 'Very Negative',
  pending: 'Pending',
}
